module.exports = __webpack_public_path__ + "static/img/12-12.0c7d9bbe.jpeg";